import { svg } from 'lit';

export const dashboardIcon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.25 4.24997V12.75H20.75V4.24997H13.25ZM19.25 11.25H14.75V5.74997H19.25V11.25ZM13.25 20.7499H20.75V14.25H13.25V20.7499ZM14.75 15.75H19.25V19.25H14.75V15.75ZM3.25 20.7499H11.75V4.24997H3.25V20.7499ZM4.75 5.74997H10.25V19.25H4.75V5.74997Z" fill="#786E5C"/>
</svg>`;
